var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardVerificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 10.5C8.51625 10.5 7.5 11.5163 7.5 12.75V23.25C7.5 24.4838 8.51625 25.5 9.75 25.5H26.25C27.4837 25.5 28.5 24.4838 28.5 23.25V12.75C28.5 11.5163 27.4837 10.5 26.25 10.5H9.75ZM9.75 12H26.25C26.6745 12 27 12.3255 27 12.75V23.25C27 23.6745 26.6745 24 26.25 24H9.75C9.3255 24 9 23.6745 9 23.25V12.75C9 12.3255 9.3255 12 9.75 12ZM14.25 13.5C12.6 13.5 11.25 14.85 11.25 16.5C11.25 17.3348 11.6077 18.0877 12.1642 18.633C11.6537 18.9775 11.2352 19.4416 10.9451 19.9849C10.6551 20.5282 10.5023 21.1341 10.5 21.75H12C12 20.499 12.999 19.5 14.25 19.5C15.501 19.5 16.5 20.499 16.5 21.75H18C17.9977 21.1341 17.8449 20.5282 17.5549 19.9849C17.2648 19.4416 16.8463 18.9775 16.3358 18.633C16.8923 18.0877 17.25 17.3355 17.25 16.5C17.25 14.85 15.9 13.5 14.25 13.5ZM19.5 14.25V15.75H25.5V14.25H19.5ZM14.25 15C15.0877 15 15.75 15.6623 15.75 16.5C15.75 17.3377 15.0877 18 14.25 18C13.4123 18 12.75 17.3377 12.75 16.5C12.75 15.6623 13.4123 15 14.25 15ZM19.5 17.25V18.75H25.5V17.25H19.5ZM19.5 20.25V21.75H23.25V20.25H19.5Z",
    fill: "#396AF2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#396AF2",
    fillOpacity: 0.24
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardVerificationIcon);
export default __webpack_public_path__ + "static/media/cardVerificationIcon.7fd9cef4e9cf0235dcbb7664de8e64ee.svg";
export { ForwardRef as ReactComponent };